import React, { useState } from "react";
import { httpRequest, toaster } from "../../../utils/utils";
import { Accordion, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import apiConstants from "../../../constans/apiConstants";
import EnachDetails from "../Policy/EnachDetails";
import { getProposalDetails } from "../../../store/actions/proposalActions";
import OperationsAccordionHeader from "../AccordionHeader";

const Policy = () => {
  const [details, setDetails] = useState({
    proposalNumber: "",
    policyNumber: "",
    uwDecision: "",
  });
  const [omini, setOmini] = useState({
    proposalNumber: "",
  });
  const [enach, setEnach] = useState({
    proposalNumber: "",
  });
  const [mobile, setMobile] = useState({
    proposalNumber: "",
    mobileNumber: "",
  });
  const [show, setShow] = useState(false);
  const [pn, setPn] = useState("");

  const userDetails = useSelector(
    (state) => state.authentication && state.authentication.user
  );
  const dispatch = useDispatch();

  const inputHandler = (e, type) => {
    if (type === "proposal") {
      setDetails({ ...details, proposalNumber: e.target.value });
    } else if (type === "policy") {
      setDetails({ ...details, policyNumber: e.target.value });
    } else {
      setDetails({ ...details, uwDecision: e.target.value });
    }
  };

  const inputHandlerOmini = (e) => {
    setOmini({ proposalNumber: e.target.value });
  };

  const inputHandlerEnach = (e) => {
    setEnach({ proposalNumber: e.target.value });
  };

  const moveItem = (e) => {
    e.preventDefault();
    const path = `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/push/omniDoc/${omini.proposalNumber}`;
    dispatch({ type: "LOADER_TRUE" });
    httpRequest(path)
      .then((res) => {
        dispatch({ type: "LOADER_FALSE" });
        if (res && res.data) {
          toaster("success", res.data.message);
        }
      })
      .catch((err) => {
        dispatch({ type: "LOADER_FALSE" });
        if (err && err.data) {
          toaster("error", err.data.message);
          setOmini({ proposalNumber: "" });
        }
      });
  };

  const updateItem = (event) => {
    event.preventDefault();
    dispatch({ type: "LOADER_TRUE" });
    const data = { ...details };
    data.agentCode = userDetails?.user?.code;
    data.role = userDetails?.user?.role;
    const path = `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/update/policyNumber`;
    httpRequest(path, data)
      .then((res) => {
        dispatch({ type: "LOADER_FALSE" });
        if (res && res.data) {
          toaster("success", res.data.message);
        }
      })
      .catch((err) => {
        dispatch({ type: "LOADER_FALSE" });
        if (err && err.data) {
          toaster("error", err.data.message);
        }
      });
  };

  const updateMobileNumber = (e, type) => {
    if (type === "proposal") {
      setMobile({ ...mobile, proposalNumber: e.target.value });
    } else if (type === "mobile") {
      if (
        e.target.value[0] < 6 ||
        e.target.value.includes(",") ||
        e.target.value.length > 10
      ) {
        return;
      }
      setMobile({ ...mobile, mobileNumber: e.target.value });
    }
  };

  const mobileInputHandler = (event) => {
    event.preventDefault();
    dispatch({ type: "LOADER_TRUE" });
    const data = { ...mobile };
    const path = `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/ops/update-mobile-number`;
    httpRequest(path, data)
      .then((res) => {
        dispatch({ type: "LOADER_FALSE" });
        if (res && res.data) {
          toaster("success", res.data.message);
          if (res.data.body) {
            setMobile({ mobileNumber: "", proposalNumber: "" });
          }
        }
      })
      .catch((err) => {
        dispatch({ type: "LOADER_FALSE" });
        if (err && err.data) {
          toaster("error", err.data.message);
        }
      });
  };

  const showDetails = (e) => {
    e.preventDefault();
    dispatch(
      getProposalDetails(enach.proposalNumber, (data) => {
        setShow(true);
        setPn(data.proposalNumber);
      })
    );
  };

  return (
    <Accordion flush className="operations-page__accordion">
      <Card className="operations-page__accordion-card">
        <Accordion.Toggle as={OperationsAccordionHeader} eventKey="0">
          Update policy number
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="0">
          <form className="operations-page__form operations-page__panel--inner">
            <div className="operations-page__field">
              <label className="operations-page__label" htmlFor="policy-proposal">
                Proposal number
              </label>
              <input
                id="policy-proposal"
                onChange={(e) => inputHandler(e, "proposal")}
                value={details.proposalNumber}
                className="operations-page__input"
                type="text"
                placeholder="Enter proposal number"
                name="proposalNumber"
              />
            </div>
            <div className="operations-page__field">
              <label className="operations-page__label" htmlFor="policy-number">
                Policy number
              </label>
              <input
                id="policy-number"
                onChange={(e) => inputHandler(e, "policy")}
                value={details.policyNumber}
                className="operations-page__input"
                type="text"
                placeholder="Enter policy number"
                name="policyNumber"
              />
            </div>
            <div className="operations-page__field">
              <label className="operations-page__label" htmlFor="policy-uw">
                UW decision
              </label>
              <input
                id="policy-uw"
                onChange={(e) => inputHandler(e, "uwDecision")}
                value={details.uwDecision}
                className="operations-page__input"
                type="text"
                placeholder="Enter UW decision"
                name="uwdecision"
              />
            </div>
            <div className="operations-page__actions">
              <button
                type="button"
                className="operations-page__btn operations-page__btn--primary"
                onClick={updateItem}
              >
                Update
              </button>
            </div>
          </form>
        </Accordion.Collapse>
      </Card>

      <Card className="operations-page__accordion-card">
        <Accordion.Toggle as={OperationsAccordionHeader} eventKey="1">
          Move documents to omni doc
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="1">
          <form className="operations-page__form operations-page__panel--inner">
            <div className="operations-page__field">
              <label className="operations-page__label" htmlFor="omni-proposal">
                Proposal number
              </label>
              <input
                id="omni-proposal"
                onChange={inputHandlerOmini}
                value={omini.proposalNumber}
                className="operations-page__input"
                type="text"
                placeholder="Enter proposal number"
                name="proposalNumber"
              />
            </div>
            <div className="operations-page__actions">
              <button
                type="button"
                className="operations-page__btn operations-page__btn--primary"
                onClick={moveItem}
              >
                Move
              </button>
            </div>
          </form>
        </Accordion.Collapse>
      </Card>

      <Card className="operations-page__accordion-card">
        <Accordion.Toggle as={OperationsAccordionHeader} eventKey="2">
          Update ENACH details
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="2">
          <form className="operations-page__form operations-page__panel--inner">
            <div className="operations-page__field">
              <label className="operations-page__label" htmlFor="enach-proposal">
                Proposal number
              </label>
              <input
                id="enach-proposal"
                onChange={inputHandlerEnach}
                value={enach.proposalNumber}
                className="operations-page__input"
                type="text"
                placeholder="Enter proposal number"
                name="proposalNumber"
              />
            </div>
            <div className="operations-page__actions">
              <button
                type="button"
                className="operations-page__btn operations-page__btn--primary"
                onClick={showDetails}
              >
                Fetch details
              </button>
            </div>
          </form>
        </Accordion.Collapse>
        {show && (
          <div className="operations-page__panel operations-page__panel--nested enachDetails_comp">
            <EnachDetails setEnach={setEnach} setShow={setShow} pn={pn} />
          </div>
        )}
      </Card>

      <Card className="operations-page__accordion-card">
        <Accordion.Toggle as={OperationsAccordionHeader} eventKey="3">
          Update mobile number
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="3">
          <form className="operations-page__form operations-page__panel--inner">
            <div className="operations-page__field">
              <label className="operations-page__label" htmlFor="mobile-proposal">
                Proposal number
              </label>
              <input
                id="mobile-proposal"
                onChange={(e) => updateMobileNumber(e, "proposal")}
                value={mobile.proposalNumber}
                className="operations-page__input"
                type="text"
                placeholder="Enter proposal number"
                name="proposalNumber"
              />
            </div>
            <div className="operations-page__field">
              <label className="operations-page__label" htmlFor="mobile-number">
                Mobile number
              </label>
              <input
                id="mobile-number"
                onChange={(e) => updateMobileNumber(e, "mobile")}
                value={mobile.mobileNumber}
                className="operations-page__input"
                type="number"
                placeholder="Enter mobile number"
                name="mobileNumber"
              />
            </div>
            <div className="operations-page__actions">
              <button
                type="button"
                className="operations-page__btn operations-page__btn--primary"
                onClick={mobileInputHandler}
              >
                Update
              </button>
            </div>
          </form>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

export default Policy;
